import "./Contact.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons";
import {useEffect, useState} from "react";
import dame from "../../Images/dame_assise.png";
import cactus from "../../Images/cactus.png";
import validator from "validator";
import Swal from "sweetalert2";
import Toast from "../../components/Toast/toast";
import {Loader} from "../../utils/Loader";

function Contact() {
    const [email, setEmail] = useState("");
    const [nomPrenom, setNomPrenom] = useState("");
    const [message, setMessage] = useState("");
    const [objetMessage, setObjetMessage] = useState("");
    const [btnContactCliquer, setBtnContactCliquer] = useState(false);
    const [formulaireValide, setFormulaireValide] = useState(false);
    const [isDataLoading, setDataLoading] = useState(false);

    const emailVerif = () => {
        return validator.isEmail(email);
    };
    
    const verificationFormulaire = () => {
        message.length > 0 && emailVerif() && nomPrenom.length > 0 && objetMessage.length > 0 ?
            setBtnContactCliquer(true) : Swal.fire({
                text: "Erreur, champs non remplis correctement",
                icon: "warning"
            });
    }

    useEffect(() => {
        document.title = "Contact";
    }, []);

    useEffect(() => {
        if (btnContactCliquer === false) return;
        const sendEmail = async () => {
            const emailInfos = {
                name: nomPrenom,
                email: email,
                message: message,
                objetMessage: objetMessage
            }
            try {
                setDataLoading(true)
                const response = await fetch(`${process.env.REACT_APP_API_URL}mail/client-to-seller`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({emailInfos}),
                    },
                );
                if (response.ok) {
                    Swal.fire({
                        title: "Email envoyé",
                        text: "Votre email a été correctement envoyé. Vous recevrez une réponse dans les plus brefs délais.",
                        icon: "success",
                        confirmButtonText: "Ok",
                    });
                    setNomPrenom("");
                    setEmail("");
                    setObjetMessage("");
                    setMessage("");
                } else {
                    Swal.fire({
                        title: "Erreur",
                        text: "Une erreur s'est produite lors de l'envoi de l'email.",
                        icon: "error",
                        confirmButtonText: "Ok",
                    });
                }
            } catch (error) {
                console.error(error);
            } finally {
                setDataLoading(false);
                setBtnContactCliquer(false);
            }
        };
        sendEmail();
    }, [btnContactCliquer])

    return (
        <>
            {formulaireValide && <Toast icon={"sucess"} text={"Email envoyé avec succès"}/>}
            <div className="body-page-contact">
                <div className="contact-card">
                    <div className="images-section">
                        <img src={cactus} alt="cactus" id="img_cactus_contact_page" />
                        <img src={dame} alt="illustration contact" id="img_dame" />
                    </div>
                    
                    <div className="form-section">
                        <h2>Me contacter</h2>
                        
                        <div className="input-group">
                            <input
                                placeholder="Nom & Prénom"
                                value={nomPrenom}
                                onChange={(e) => setNomPrenom(e.target.value)}
                            />
                        </div>
                        
                        <div className="input-group">
                            <input
                                placeholder="Adresse Email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        
                        <div className="input-group">
                            <input
                                placeholder="Sujet de votre message"
                                value={objetMessage}
                                onChange={(e) => setObjetMessage(e.target.value)}
                            />
                        </div>
                        
                        <div className="input-group">
                            <textarea
                                placeholder="Écrivez votre message ici..."
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                            />
                        </div>

                        {isDataLoading ? (
                            <div style={{display: 'flex', justifyContent: 'center', marginTop: '1rem'}}>
                                <Loader />
                            </div>
                        ) : (
                            <button id="btn_contact" onClick={() => verificationFormulaire()}>
                                Envoyer le message
                                <FontAwesomeIcon icon={faEnvelope} className="icon-signIn"/>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Contact;
